<template>
    <div class="dropdown-panel">
        <div class="dropdown-panel-header">
            <div v-if="!hideToggle" class="dropdown-panel-button" @click="toggleDropdownPanel">
                <div v-if="isDropdownPanelOpen">
                    <font-awesome-icon :icon="['fa-solid', 'fa-minus']" />
                </div>
                <div v-else><font-awesome-icon :icon="['fasr', 'fa-plus']" /></div>
                <div class="dropdown-panel-label h5">{{ buttonLabel + additionalLabel }}</div>
            </div>
            <slot name="header-content"></slot>
        </div>
        <div v-if="isDropdownPanelOpen" class="dropdown-panel-content">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DropdownPanel',
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        additionalLabel: {
            type: String,
            default: '',
        },
        hideToggle: {
            type: Boolean,
            default: false,
        },
        description: {
            type: String,
            default: '',

        }
    },
    watch: {
        isOpen: {
            handler(open) {
                this.isDropdownPanelOpen = open;
            },
            deep: true,
            immediate: true,
        },
    },
    data() {
        return {
            isDropdownPanelOpen: this.isOpen,
            buttonLabel: this.isOpen ? 'Hide ' : 'Show ',
        };
    },
    methods: {
        toggleDropdownPanel() {
            this.isDropdownPanelOpen = !this.isDropdownPanelOpen;
            this.buttonLabel = this.isDropdownPanelOpen ? 'Hide ' : 'Show ';
            this.$emit('toggle', this.isDropdownPanelOpen);
        },
    },
};
</script>
